import { useState, useEffect } from "react";
import axios from "axios";
import { getAntiForgeryToken } from "../utils/Fetch";

export interface ILogPlusPersonData {
    Id: string,

    LogId: number,
    FirstName: string,
    LastName: string,
    Login: string,
    Email: string,
    JobPosition: string,
    SapId: string,
    SupervisorId: number | null;
    SupervisorName: string;
}

export interface ILogPlusDeviceData {
    Id: string,

    LogId: number,
    Name: string,
    Type: string,
    SerialNumber: string,
    Model: string,
    
    Description: string,
    InventoryNumber: string,
}

export interface ILogPlusComputerData extends ILogPlusDeviceData {
    DomainName: string,
}

export interface ILogPlusDataCarrierData extends ILogPlusDeviceData{
    
}

export interface ILogPlusMobileDeviceData extends ILogPlusDeviceData {

}

export interface ILogPlusMonitorData extends ILogPlusDeviceData {

}

export interface ILogPlusNetworkDeviceData extends ILogPlusDeviceData {

}

export interface ILogPlusPrinterData extends ILogPlusDeviceData {

}

export interface ILogPlusAccessoryData extends ILogPlusDeviceData {

}

export interface ILogPlusPhoneNumberData extends ILogPlusDeviceData {

}

export interface ILogPlusItSystemData {
    Id: string,

    LogId: number,
    Name: string,
    Type: string,
    Description: string,
}

export interface ILogPlusAgreementData {
    Id: string,

    LogId: number,
    Name: string,
    Type: string,
    Description: string,
    AgreementNumber: string,
}

export interface ILogPlusLicenseData {
    Id: string,

    LogId: number,
    Name: string,
    LicenseType: string,
    LicenseTypeDescription: string,
    Description: string,
}

export interface ILogPlusServiceData {
    Id: string,

    LogId: number,
    Name: string,
    Icon: string,
    ServiceType: string,
    OwnId: string,

    OwnerId: number | null,
    OwnerName: string,

    ServiceProfileId: number | null,
    ServiceProfileName: string,

    ServiceProfileGroupId: number | null,
    ServiceProfileGroupName: string,
}

export interface IGetIssueLogPlusResourcesResultData {
    Person: ILogPlusPersonData[],
    ItSystem: ILogPlusItSystemData[],
    Agreement: ILogPlusAgreementData[],
    License: ILogPlusLicenseData[],
    Service: ILogPlusServiceData[],

    Computer: ILogPlusComputerData[],
    DataCarrier: ILogPlusDataCarrierData[],
    MobileDevice: ILogPlusMobileDeviceData[],
    Monitor: ILogPlusMonitorData[],
    NetworkDevice: ILogPlusNetworkDeviceData[],
    Printer: ILogPlusPrinterData[],
    Accessory: ILogPlusAccessoryData[],
    PhoneNumber: ILogPlusPhoneNumberData[],
}

interface IGetIssueLogPlusResourcesRequestData {
	issueId: number,
}

type GetIssueLogPlusResourcesApi = [(m: IGetIssueLogPlusResourcesRequestData) => void, IGetIssueLogPlusResourcesResultData, boolean, boolean];
export const useGetIssueLogPlusResourcesApi: () => GetIssueLogPlusResourcesApi = () => {
	const [model, setModel] = useState<IGetIssueLogPlusResourcesRequestData>(null);
	const [result, setResult] = useState<IGetIssueLogPlusResourcesResultData>(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            try {
				const result = await axios.get(`/IssueLogPlusResources/GetResources/?issueId=${model.issueId}`);
                setResult(result.data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (!model)
            return;

        fetchData();
    }, [model]);

    return [setModel, result, isLoading, isError];
}

export interface ISaveIssueLogPlusResourcesRequestData {
    issueId: number,

    Person?: number[],
    ItSystem?: number[],
    Agreement?: number[],
    License?: number[],
    Service?: number[],

    Computer?: number[],
    DataCarrier?: number[],
    MobileDevice?: number[],
    Monitor?: number[],
    NetworkDevice?: number[],
    Printer?: number[],
    Accessory?: number[],
    PhoneNumber?: number[],
}

export interface ISaveIssueLogPlusResourcesResultData {
    success: boolean,
}

type SaveIssueLogPlusResourcesApi = [(m: ISaveIssueLogPlusResourcesRequestData) => void, ISaveIssueLogPlusResourcesResultData, boolean, boolean];
export const useSaveIssueAccessesDetailsApi: () => SaveIssueLogPlusResourcesApi = () => {
    const [model, setModel] = useState<ISaveIssueLogPlusResourcesRequestData>(null);
    const [result, setResult] = useState<ISaveIssueLogPlusResourcesResultData>(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            setResult(null);
            try {
                const result = await axios.post<ISaveIssueLogPlusResourcesResultData>(`/IssueLogPlusResources/SaveResources/?issueId=${model.issueId}`, model, {
                    headers: {
                        __RequestVerificationToken: getAntiForgeryToken(),
                    }
                });
                setResult(result.data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (!model)
            return;

        fetchData();
    }, [model]);

    return [setModel, result, isLoading, isError];
}